import "./Header.scss";
const Header = () => {
  return (
    <div className="header">
      <span className="text-shadow">Mantar Alemi</span>
    </div>
  );
};

export default Header;
